module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Attribute \\"{attribute}\\"","label":"Attribute","history":"History"},"ru":{"title":"Атрибут \\"{attribute}\\"","label":"Атрибут","history":"История"}}')
  delete Component.options._Ctor
}
